import { AuthGuard } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { z } from 'zod';

import { AccountPage } from '../pages/account';

export const Route = createFileRoute('/account')({
  validateSearch: z.object({
    tab: z.enum(['profile', 'programs', 'security', 'pro-directory']).optional().catch(undefined),
  }),
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <AccountPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
